<template>
  <el-dialog :title="title" :visible.sync="visible" :lock-scroll="true" width="818px" :before-close="handleClose">
    <div class="">
      <div style="padding: 0px 0;">
        <el-form ref="form-data" :model="form" :inline="false" label-width="150px" label-position="right" :rules="rules"
          style="text-align:left;">
          <el-form-item prop="name" label="广告位名称">
            <el-input v-model.tirm="form.name" style="width: 400px;" placeholder="请输入" clearable size="small"
            show-word-limit maxlength="50"
              :disabled="isDisabled" />
          </el-form-item>

          <el-form-item prop="positionDescription" label="位置描述">
            <el-input v-model.tirm="form.positionDescription" style="width: 400px;" placeholder="请输入" clearable
            show-word-limit maxlength="50"
              size="small" :disabled="isDisabled" />
          </el-form-item>

          <el-form-item prop="platform" label="广告位置所属平台">
            <el-select v-model="form.platform" clearable style="width: 160px;" size="small" placeholder="请选择平台端"
              :disabled="isDisabled">
              <el-option v-for="item in sourceTypeOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="previewImageList" label="位置预览图">
            <imgUpload v-model="form.previewImageList" :isEdit="isDisabled" :limit="1" @onRemoveHandler="onRemoveHandler"
              @onSuccessUpload="onSuccessUpload" style="position:relative;top:0px;">
              <template slot="tip">
                <p class="el-upload__tip">
                  图片用于提示广告在平台的展示位置，建议平台截图标识，图片大小1M以内，
                  <br />
                  图片格式支持 .jpg、.jpge、.png。
                </p>
              </template>
            </imgUpload>
          </el-form-item>

          <el-form-item prop="defaultImageList" label="位置缺省图">
            <imgUpload v-model="form.defaultImageList" :isEdit="isDisabled" :limit="1" @onRemoveHandler="onRemoveHandler"
              @onSuccessUpload="onSuccessUpload2" style="position:relative;top:0px;">
              <template slot="tip">
                <p class="el-upload__tip">
                  图片用于提示广告在平台的展示位置，建议平台截图标识，图片大小1M以内，
                  <br />
                  图片格式支持 .jpg、.jpge、.png。
                </p>
              </template>
            </imgUpload>
          </el-form-item>

          <el-form-item prop="width" label="图片尺寸（像素）" style="margin-bottom: 0;">
            <div class="pic-px">
              <el-form-item prop="width">
                <el-input v-model.tirm="form.width" style="width: 120px;" placeholder="请输入宽" clearable size="small"
                  :maxlength="4" @keyup.native="proving1" type="text" :disabled="isDisabled" :min="1" />
              </el-form-item>

              <span>*</span>
              <el-form-item prop="height">
                <el-input v-model.tirm="form.height" style="width: 120px;" placeholder="请输入高" clearable size="small"
                  :maxlength="4" @keyup.native="proving2" type="text" :disabled="isDisabled" :min="1" />
              </el-form-item>
            </div>


          </el-form-item>

          <el-form-item prop="layout" label="图片展示方向">
            <el-radio-group v-model="form.layout" style="margin-top: 10px" :disabled="isDisabled">
              <el-radio :label="0">横向</el-radio>
              <el-radio :label="1">纵向</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item prop="maxImageNum" label="最多上传图片数">
            <el-input v-model.tirm="form.maxImageNum" style="width: 200px;" placeholder="请输入" clearable size="small"
              @keyup.native="proving3" type="text" :disabled="isDisabled" />
          </el-form-item>

          <el-form-item prop="dwellTime" label=" 广告轮播时间">
            设置多广告图片轮播时，单张图片停留时长
            <el-select v-model="form.dwellTime" clearable style="width: 100px;" size="small" :disabled="isDisabled">
              <el-option v-for="item in timeOptions" :key="item.value" :label="item.value" :value="item.value">
              </el-option>
            </el-select>
            秒
          </el-form-item>


          <el-form-item>
            <el-button size="small" type="success" @click="handleClose()" :disabled="isDisabled">取消</el-button>
            <el-button size="small" type="primary" @click="saveSubmit()" :disabled="isDisabled">确定</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </el-dialog>
</template>
    
<script>

import { positionSettingSave, positionSettingGetInfo, } from "@/api/bannerManage";
import avater from "/public/img/default.png";
import imgUpload from '@/components/imgUpload';
export default {
  props: {},
  data() {
    return {
      avater: avater,
      disabled: false,
      id: '',
      pageType: '',
      isDisabled: false,
      form: {
        "name": "",
        "positionDescription": "",
        "previewImage": "",
        "defaultImage": "",
        "previewImageList": [],
        "defaultImageList": [],
        "platform": null,
        "height": '',
        "width": '',
        "layout": 0,
        "maxImageNum": '',
        "dwellTime": null,
      },
      sourceTypeOptions: [
        {
          value: 'MERCHANT_PC',
          label: '商户端(PC)'
        },
        {
          value: 'MERCHANT_APP',
          label: '商户端(APP)'
        },
        {
          value: 'CLIENT_PC',
          label: '客户端(PC)'
        },
        {
          value: 'CLIENT_APP',
          label: '客户端(APP)'
        },
        {
          value: 'CLIENT_MINI',
          label: '客户端(小程序)'
        },
        {
          value: 'BUSINESS_PC',
          label: '业务端PC'
        },
        {
          value: 'BUSINESS_APP',
          label: '业务端(APP)'
        },
      ],
      timeOptions: [
        {
          value: 5
        },
        {
          value: 6
        },
        {
          value: 7
        },
        {
          value: 8
        },
        {
          value: 9
        },
        {
          value: 10
        },
      ],
      rules: {
        name: [{ required: true, message: '请填写广告位名称', trigger: 'blur' }],
        positionDescription: [{ required: true, message: '请填写位置描述', trigger: 'blur' }],
        previewImageList: [{ required: false, message: '请上传预览图', trigger: 'blur' }],
        defaultImageList: [{ required: true, message: '请上传缺省图', trigger: 'blur' }],
        platform: [{ required: true, message: '请选择所属平台', trigger: 'change' }],
        width: [{ required: true, message: '请填写图片尺寸（宽度）', trigger: 'blur' }],
        height: [{ required: true, message: '请填写图片尺寸（高度）', trigger: 'blur' }],
        layout: [{ required: true, message: '请选择图片展示方向', trigger: 'blur' }],
        maxImageNum: [{ required: true, message: '请填写最大上传图片数量', trigger: 'blur' }],
        dwellTime: [{ required: true, message: '请选择轮播图停留时间', trigger: 'change' }],
      },
      title: '',
      visible: false,
    }
  },
  components: { imgUpload },
  created() {

  },
  mounted() {

  },
  watch: {},
  methods: {
    //      验证只能输入正整数
    proving1() {
      this.form.width = this.form.width.replace(/[^\.\d]/g, '');
      this.form.width = this.form.width.replace('.', '');
    },
    //      验证只能输入正整数
    proving2() {
      this.form.height = this.form.height.replace(/[^\.\d]/g, '');
      this.form.height = this.form.height.replace('.', '');
    },

    //      验证只能输入正整数
    proving3() {
      this.form.maxImageNum = this.form.maxImageNum.replace(/[^\.\d]/g, '');
      this.form.maxImageNum = this.form.maxImageNum.replace('.', '');
    },
    onRemoveHandler(file) {
      console.log(file)
    },
    saveSubmit() {
      let params = {
        "id": this.form.id
      }
      if (this.form.previewImageList) {
        this.form.previewImage = this.form.previewImageList.join(',');
      }
      if (this.form.defaultImageList) {
        this.form.defaultImage = this.form.defaultImageList.join(',');
      }

      this.$refs['form-data'].validate((valid) => {
        if (valid) {
          positionSettingSave({ ...params, ...this.form }).then((res) => {
            if (res) {
              this.$message.success('提交成功');
              this.$emit('getList')
              this.handleClose();
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })

    },

    onSuccessUpload(e) {
      // console.log(this.form.previewImageList, 'eee')
    },
    onSuccessUpload2(e) {
      // console.log(this.form.defaultImageList, 'eee2')
    },
    handleClose() {
      this.reset();
      this.$refs['form-data'].resetFields();
      this.visible = false;
    },

    reset() {
      Object.keys(this.form).forEach((key) => (this.form[key] = ""));
      this.form.defaultImageList = [];
      this.form.previewImageList = [];
      this.form.layout = 0;
      this.form.platform = null;
      console.log(this.form, '----this.form2')
    },
    init(row, type) {
      this.title = '广告位设置';
      if (type == 'detail') {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
      if (row && row.id) {
        this.query(row.id);
      } else {
        this.visible = true;
        this.reset();
      }
      console.log(this.form)
      this.$forceUpdate();
    },
    query(id) {
      positionSettingGetInfo(id).then(res => {
        this.form = Object.assign(this.form, res);
        if (res.defaultImage) {
          this.form.defaultImageList = [res.defaultImage];
        }
        if (res.previewImage) {
          this.form.previewImageList = [res.previewImage];
        }
        console.log(this.form, '---this.form')
        this.visible = true;
      })
    },
  }
}

</script>
<style lang="scss" scoped>
.eachRow {
  background-color: #fff;
  border-radius: 4px;
  padding-top: 24px;
  display: flex;
  flex-direction: column;
}

.titleView {
  display: flex;
  align-items: center;

  .rowLine {
    width: 4px;
    border-color: 1px;
    background-color: var(--main-color);
    height: 16px;
    margin-right: 8px;
  }

  .eachRowTitle {
    font-size: 16px;
    color: #262626;
    font-weight: 600;
  }

  .cpxhead {
    display: flex;
    align-items: center;
  }

  .mark {
    color: #f56c6c;
    font-size: 12px;
    margin-left: 10px;
    width: 200px;
    line-height: 1.5;
    display: inline-block;
    font-weight: bold;
  }
}

.goods-list-warp {
  width: 100%;
  margin-left: 100px;
  max-height: 500px;
  overflow-y: auto;
}

.goods-list {
  width: 50%;
  border-bottom: solid 1px #f5f5f5;
  padding-bottom: 10px;

  &:nth-last-child(1) {
    border-bottom: none;
  }
}

.pic-px {
  width: 280px;
  height: 32px;
  display: flex;
  justify-content: space-between;
}
</style>
  
  